import * as yup from "yup";
import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { logFetchValidateError } from "@utils/validate";
import {
  CheckInDictionary,
  checkInDictionarySchema,
} from "@client/resources/DailyCheckinResource";

export type FetchDailyCheckinDictionaryResponse =
  ApiResponse<CheckInDictionary>;

export async function fetchDailyCheckinDictionary(): Promise<FetchDailyCheckinDictionaryResponse> {
  const response = await fetchData(
    `/dietitian/dictionaries/daily-checkin`,
    APIMethods.GET,
  );

  return schema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/dictionaries/daily-checkin"));
}

const schema = yup.object({
  data: checkInDictionarySchema.required(),
});
